
export default {
  i18nComponentKey: 'ReviewsNew.components.AiKeywordInfoDialog',
  name: 'AiKeywordInfoDialog'
};
